import ReactTooltip from "react-tooltip";

// eslint-disable-next-line react/forbid-elements
const ReactTooltipWrapper = () => <ReactTooltip effect="solid" />;
export default ReactTooltipWrapper;
